/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
import * as React from 'react';
import { useEffect, useState, useContext, useCallback } from 'react';

import { useUserInfo } from '../user-info';
import { CurrentWalletInfo } from './service';
import {
  getWalletInfoByApp,
  switchWalletByApp,
  web3PurchaseWallet,
  goSend,
  goReceive,
  isApp,
} from '@web3/base-utils';

/**
 * React Context for WalletInfo
 */
export const WalletInfoContext = React.createContext({
  // 获取钱包信息
  currentWalletInfo: undefined,
  // 指定币的信息，获取对应的地址，比如btc，eth这些
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getAddressByCodeName: (chainCode: string) => {
    return '' as string;
  },
  // 是否是云钱包
  isCloudWallet: false,
  isWalletConnected: false,
  // 再次点击获取钱包地址信息
  getCurrentWallet: () => {
    return;
  },
  // 切换钱包弹窗
  handleSwitchWallet: (onSuccessCb?: () => void, onFailedCb?: () => void) => {
    return;
  },
  // 打开Deposit弹窗
  handleDeposit: (chainCode?: string, coinName?: string) => {
    return;
  },
  // 打开Deposit弹窗
  handleDepositAll: (chainCode?: string, coinName?: string) => {
    return;
  },
  // pubkey
  pubKey: '',
  setPubKey: (pubKey: string) => {
    return;
  },
  assetInfo: undefined,
  handleToggleAssets: () => {
    return;
  },
  handleWithdrawAll: () => {
    return;
  },
  connectWalletVisible: false,
  handleConnectWallet: () => {
    return;
  },
  handleCopyWallet: () => {
    return;
  },
  handleCreateWallet: () => {
    return;
  },
});

WalletInfoContext.displayName = 'WalletInfoContext';

interface WalletInfoProviderProps {
  children: React.ReactNode;
}

function getChainTypeByWeb(chainType: number) {
  switch (chainType) {
    case 1:
      return 'ETH';
    case 2:
      return 'SUI';
    case 3:
      return 'SOLANA';
    case 4:
      return 'BTC';
    default:
      return 'others';
  }
}

export const WalletInfoProvider = (props: WalletInfoProviderProps) => {
  const { children } = props;
  const { isLogin } = useUserInfo();
  const [currentWalletInfo, setCurrentWalletInfo] =
    useState<CurrentWalletInfo>();
  const [assetInfo, setAssetInfo] = useState<CurrentWalletInfo>();

  const [pubKey, setPubKey] = useState<string>('');
  const [connectWalletVisible, setConnectWalletVisible] = useState(false);

  const getCurrentWalletByWeb = useCallback(() => {
    window.$wujie?.bus.$emit('getCurrentWalletInfo');
    window.$wujie?.bus.$emit('getAssetInfo');

    window.$wujie?.bus.$on('assetInfo', (data) => {
      setAssetInfo(data);
      console.log('assetInfo', data);
    });

    window.$wujie?.bus.$on('showWalletConnectModal', (data) => {
      setConnectWalletVisible(data.visible);
    });

    window.$wujie?.bus.$on('currentWallet', (data) => {
      if (!isApp() && data && data.length > 0) {
        // debugger;
        let webCurrentWalletInfo: CurrentWalletInfo;
        // 大于1 说明是我们自己的云钱包
        if (data[0].walletType === 'CLOUD') {
          const info = data[0];
          webCurrentWalletInfo = {
            address: info.address,
            name: info.alias,
            logo: info.logo,
            type: 'CLOUD',
            // 第三方钱包目前还不支持解析
            supportChainList: data.map((k) => {
              return {
                address: k.address,
                chainId: k.chainType,
                chainCode: getChainTypeByWeb(k.chainType),
              };
            }),
          };
        } else {
          const info = data[0];
          webCurrentWalletInfo = {
            address: info.address,
            name: info.alias,
            logo: info.logo,
            type: 'THIRD_PARTY',
            // 第三方钱包目前还不支持解析
            supportChainList: [
              {
                address: info.address,
                chainId: info.chainType,
                chainCode: getChainTypeByWeb(info.chainType),
              },
            ],
          };
        }

        console.log('current wallet info:', webCurrentWalletInfo);

        setCurrentWalletInfo(webCurrentWalletInfo);
      }
    });

    // 等1s再获取钱包信息，防止获取不到

    setTimeout(() => {
      window.$wujie?.bus.$emit('getCurrentWalletInfo');
      window.$wujie?.bus.$emit('getAssetInfo');
    }, 1000);
    return;
  }, []);

  const getCurrentWallet = useCallback(async () => {
    // if (!isLogin) {
    //   return;
    // }
    if (isApp()) {
      const res = await getWalletInfoByApp();

      if (res) {
        setCurrentWalletInfo(
          // TODO：处理chainId类型问题(string or number)
          (res?.params?.result as unknown as CurrentWalletInfo) ||
            ({
              type: '',
              address: '',
              name: '',
              supportChainList: [],
            } as CurrentWalletInfo)
        );
      }
    } else {
      getCurrentWalletByWeb();
    }
  }, [isLogin]);

  const getAddressByCodeName = useCallback(
    (chainName: string) => {
      if (currentWalletInfo && currentWalletInfo.supportChainList.length > 0) {
        const find = currentWalletInfo.supportChainList.find(
          (k) => k.chainCode === chainName
        );
        return find ? find.address : '';
      }
      return '';
    },
    [currentWalletInfo]
  );

  const handleSwitchWallet = useCallback(
    async (onSuccessCb?: () => void, onFailedCb?: () => void) => {
      if (!isLogin) {
        return;
      }
      if (isApp()) {
        try {
          await switchWalletByApp();
          onSuccessCb();
        } catch (e) {
          onFailedCb();
        }
      } else {
        window.$wujie?.bus.$emit('switchWallet');
      }
    },
    [isLogin]
  );

  const handleCopyWallet = useCallback(
    (onSuccessCb?: () => void, onFailedCb?: () => void) => {
      if (!isLogin) {
        return;
      }
      if (isApp()) {
        // switchWallet(onSuccessCb, onFailedCb);
      } else {
        window.$wujie?.bus.$emit('showCopyWallet');
      }
    },
    [isLogin]
  );

  const handleConnectWallet = useCallback(
    async (onSuccessCb?: () => void, onFailedCb?: () => void) => {
      // if (!isLogin) {
      //   return;
      // }
      if (isApp()) {
        try {
          await switchWalletByApp();
          onSuccessCb();
        } catch (e) {
          onFailedCb();
        }
      } else {
        window.$wujie?.bus.$emit('showConnectWallet');
      }
    },
    [isLogin]
  );

  const handleCreateWallet = useCallback(
    async (onSuccessCb?: () => void, onFailedCb?: () => void) => {
      if (!isLogin) {
        return;
      }
      if (isApp()) {
        try {
          await switchWalletByApp();
          onSuccessCb();
        } catch (e) {
          onFailedCb();
        }
      } else {
        window.$wujie?.bus.$emit('createWallet');
      }
    },
    [isLogin]
  );

  const handleDeposit = useCallback(
    (chainCode = 'BTC', coinName = 'BTC') => {
      if (!isLogin) {
        return;
      }
      if (isApp()) {
        web3PurchaseWallet(chainCode, coinName);
      } else {
        window.$wujie?.bus.$emit('deposit', {
          chainCode,
          token: coinName,
        });
      }
      return;
    },
    [isLogin]
  );

  const handleDepositAll = useCallback(() => {
    if (!isLogin) {
      return;
    }
    if (isApp()) {
      // ['chainCode', 'coinName', 'address'];
      goReceive({
        chainCode: 'BTC',
        coinName: 'BTC',
        address: getAddressByCodeName('BTC'),
      });
      // web3PurchaseWallet(chainCode, coinName);
    } else {
      window.$wujie?.bus.$emit('depositAll');
    }
    return;
  }, [isLogin]);

  const handleWithdrawAll = useCallback(() => {
    if (!isLogin) {
      return;
    }
    if (isApp()) {
      goSend({
        chainCode: 'BTC',
        coinName: 'BTC',
        address: getAddressByCodeName('BTC'),
      } as any);
    } else {
      window.$wujie?.bus.$emit('showWithdrawModal');
    }
    return;
  }, [isLogin]);

  const handleToggleAssets = useCallback(() => {
    // if (!isLogin) {
    //   return;
    // }
    if (isApp()) {
      // web3PurchaseWallet(chainCode, coinName);
    } else {
      window.$wujie?.bus.$emit('toggleShowAssets');
    }
    return;
  }, [isLogin]);

  const isCloudWallet = React.useMemo(() => {
    if (!isLogin) {
      return false;
    }
    return currentWalletInfo?.type === 'CLOUD' ? true : false;
  }, [isLogin, currentWalletInfo]);

  const isWalletConnected = currentWalletInfo != null;

  useEffect(() => {
    getCurrentWallet();
    (window.parent as Window & { onWalletChange: () => void }).onWalletChange =
      () => {
        getCurrentWallet();
      };

    return () => {
      (
        window.parent as Window & { onWalletChange: () => void }
      ).onWalletChange = null;
    };
  }, [getCurrentWallet]);

  return (
    <WalletInfoContext.Provider
      value={{
        currentWalletInfo,
        getCurrentWallet,
        handleDeposit,
        handleSwitchWallet,
        isCloudWallet,
        assetInfo,
        isWalletConnected,
        getAddressByCodeName,
        pubKey,
        setPubKey,
        handleCopyWallet,
        connectWalletVisible,
        handleConnectWallet,
        handleToggleAssets,
        handleDepositAll,
        handleWithdrawAll,
        handleCreateWallet,
      }}
    >
      {children}
    </WalletInfoContext.Provider>
  );
};
/**
 * Custom React Hooks
 */
export const useWalletInfo = () => {
  const context = useContext(WalletInfoContext);
  return context;
};

export default WalletInfoContext;
